(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerSourceProfileController', [
            'MW.ContactManager.ContactManagerSourceService',
            'MW.ContactManager.ContactManagerFlashService',
            'MW.ContactManager.RecentDocuments',
            'MW.CoreStream',
            'MW.Framework.ContentStreamSelectionDecorator',
            'MW.Framework.ContactFilter',
            'MW.Framework.InfluencerContactService',
            'MW.Framework.PredictionPanelService',
            'MW.Framework.ContentStreamDataFactory',
            'MW.CoreStream.ContactManagerTagService',
            'MW.Framework.PageStateService',
            'MW.Influencers.IcmDialogService',
            'MW.CoreStream.CsSelectAllHeader',
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'ngMaterial',
            'MW.Influencers.AnalyticsService',
            'MW.Influencers.FeedbackService',
            'angular-inview',
            'MW.Influencers.MiniProfileService'
        ])
        .controller('ContactManagerSourceProfileController', [
            'ContactManagerSourceService',
            'breadcrumbs',
            '$routeParams',
            'ContactManagerFlashService',
            'InfluencerContactService',
            'ContentStreamSelectionDecorator',
            'PredictionPanelService',
            'ContactManagerTagService',
            'PageStateService',
            'DialogService',
            'MAX_MEDIALIST_LIMIT',
            'ContactStreamDataFactory',
            'CoreUserService',
            'CoreCompanyService',
            'AnalyticsService',
            'FeedbackService',
            '$mdDialog',
            '$q',
            '$http',
            '$translate',
            '$timeout',
            '$location',
            '$rootScope',
            '$scope',
            'ICM_CSS_URL',
            'MiniProfileService',
            ContactManagerSourceProfileController
        ]);

        function ContactManagerSourceProfileController(
            ContactManagerSourceService,
            breadcrumbs,
            $routeParams,
            ContactManagerFlashService,
            InfluencerContactService,
            ContentStreamSelectionDecorator,
            PredictionPanelService,
            ContactManagerTagService,
            PageStateService,
            DialogService,
            MAX_MEDIALIST_LIMIT,
            ContactStreamDataFactory,
            CoreUserService,
            CoreCompanyService,
            AnalyticsService,
            FeedbackService,
            $mdDialog,
            $q,
            $http,
            $translate,
            $timeout,
            $location,
            $rootScope,
            $scope,
            ICM_CSS_URL,
            MiniProfileService
        ) {
            this.$location = $location;
            this.$timeout = $timeout;
            this.$routeParams = $routeParams;
            this.breadcrumbs = breadcrumbs;
            this.ContactManagerSourceService = ContactManagerSourceService;
            this.InfluencerContactService = InfluencerContactService;
            this.PredictionPanelService = PredictionPanelService;
            this.ContactManagerTagService = ContactManagerTagService;
            this.PageStateService = PageStateService;
            this.DialogService = DialogService;
            this.$mdDialog = $mdDialog;
            this.CoreUserService = CoreUserService;
            this.CoreCompanyService = CoreCompanyService;
            this.AnalyticsService = AnalyticsService;
            this.FeedbackService = FeedbackService;
            this.MiniProfileService = MiniProfileService;
            this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
            this.$translate = $translate;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$q = $q;
            this.$http = $http;

            this.ICM_CSS_URL = ICM_CSS_URL;
            this.source = {};
            this.parentChildIds = [];
            this.contactPredictionPanelExpanded = false;
            this.predictionContactFilter = {};
            this.sortField = 'alphabetically';

            this.ContactSelector = new ContentStreamSelectionDecorator({
                idField: 'id',
                filterName: 'contactFilter'
            });

            this.ContactStreamData = new ContactStreamDataFactory();

            ContactManagerSourceService.getSourceById($routeParams.sourceId).then(function(response) {
                this.source = response;

                this.parentChildIds = [response.id];
                if(Array.isArray(response.childIds) && (response.childIds.length > 0)) {
                    this.parentChildIds = this.parentChildIds.concat(response.childIds);
                }

                if(this.source.contactInfo && this.source.contactInfo.addresses && this.source.contactInfo.addresses.length > 0 ) {
                    for(var i = 0 ; i < this.source.contactInfo.addresses.length; i++) {
                        var addressFieldArray = ['city', 'countryCode', 'countryName', 'stateOrProvince', 'street', 'street2', 'zip'];
                        this.source.contactInfo.addresses[i].isAddressEmpty = true;

                        for(var field in addressFieldArray) {
                            if (this.source.contactInfo.addresses[i][addressFieldArray[field]] !== '') {
                                this.source.contactInfo.addresses[i].isAddressEmpty = false;
                                break;
                            }
                        }
                    }
                }
                this.FeedbackService.initializeSource(this.source);
            }.bind(this)).catch(function(err) {
                ContactManagerFlashService.flashError(err);
            });

            this.query = {};

            this.findFilterPromise = null; //promise for find filter debounce

            this.pageState = {};
            if (Object.keys(this.$location.search()).length === 0) {
                this.PageStateService.initializeSaveState();
                this.PageStateService.set(this.$location.search().locker, this.pageState, 'sourceProfile');
                this.$location.replace();
            }

            var possiblePageState = this.PageStateService.get('sourceProfile');
            if(possiblePageState && Object.keys(possiblePageState).length > 0 && possiblePageState.constructor === Object) {
                this.pageState = possiblePageState;
                this.findFilterExpanded = this.pageState.findString ? true : false;
            }

            window.addEventListener('app-chrome-drawer-closed', closeMini, false);
            this.$scope.$on('$locationChangeStart', function(event, next) { // PAGE CHANGE
                if (!next.includes('/source')) {
                    window.removeEventListener('app-chrome-drawer-closed', closeMini, false);
                }
            }.bind(this));

            this.scrollToTop();
            this.search();

            this.ContactSelector.deselectAll();
        }

        ContactManagerSourceProfileController.prototype.search = function search() {

            this.query.filters = [];
            this.query.filters.push({
                type: 'sources',
                sourceIds: [this.$routeParams.sourceId]
            });

            if(this.pageState.findString) {
                this.query.filters.push({
                    type: 'freeTextContact',
                    q: this.pageState.findString
                });
            }
            this.ContactStreamData.aggregateSearch(this.query);
        };

        ContactManagerSourceProfileController.prototype.findFilterSearch = function findfilterSearch(searchTerm) {
            if(this.findFilterPromise){
                this.$timeout.cancel(this.findFilterPromise);
            }

            this.pageState.findString = searchTerm || '';
            this.setPageState();

            //Only search if we have at least two characters, or reset if the filter text is gone
            if (this.pageState.findString.length > 2 || this.pageState.findString.length === 0) {
                this.findFilterPromise = this.$timeout(()=>{
                    this.search();
                }, 300);
            }
        };

        function closeMini() {
            let _this = angular.element(document.getElementsByClassName('sourceProfilePage')).scope().sourceController;
            _this.MiniProfileService.closeMiniProfile();
            _this.$scope.$apply();
        }

        ContactManagerSourceProfileController.prototype.highlightSelectedContact = function selectedContact(cardContactID) {
            return cardContactID === this.MiniProfileService.miniProfileId;
        };

        ContactManagerSourceProfileController.prototype.setPageState = function setPageState() {
            this.PageStateService.set('sourceProfile', this.pageState);
        };

        ContactManagerSourceProfileController.prototype.showActionButtons = function showActionButtons() {
            return Object.keys(this.ContactSelector.selectedItems).length > 0;
        };

        ContactManagerSourceProfileController.prototype.viewContact = function viewContact(contact) {
            this.InfluencerContactService.setCurrentContact(contact);
            this.MiniProfileService.openMiniProfile(contact.id, true);
        };

        ContactManagerSourceProfileController.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
            return Object.keys(selectedItems).length;
        };

        ContactManagerSourceProfileController.prototype.resetSelections = function resetSelections(){
            this.ContactSelector.deselectAll();
        };

        ContactManagerSourceProfileController.prototype.tagSelectedContacts = function tagSelectedContacts() {
            let selectedContactIds = Object.keys(this.ContactSelector.selectedItems);

            if (this.ContactSelector.trueAllSelected && this.ContactStreamData.totalContacts > this.MAX_MEDIALIST_LIMIT || selectedContactIds.length >  this.MAX_MEDIALIST_LIMIT) {
                let manageListLimitWarning = document.querySelector('manage-list-limit-warning');
                manageListLimitWarning.open();
            }
            else {
                window.addEventListener('icm-lists-updated', this.refreshMediaList, {once: true});
                this.addToMediaListModal(selectedContactIds);
            }
        };

        ContactManagerSourceProfileController.prototype.addToMediaListModal = function (selectedContactIds) {
            let manageListDialog = document.querySelector('icm-manage-lists-dialog');

            if (this.ContactSelector.trueAllSelected === true) {
                manageListDialog.openLoading();

                let query = JSON.parse(JSON.stringify(this.query));
                query.pageSize = this.MAX_MEDIALIST_LIMIT;
                query.page = 0;
                this.InfluencerContactService.aggregateContactSearch(query).then((response) => {
                    let contactIds = response.hits.map((contact) =>{
                        return contact.id;
                    });
                    manageListDialog.open(contactIds);
                }).catch(function(err) {
                    manageListDialog.showLoadingErrorState();
                    console.err(err);
                });
            }
            else {
                manageListDialog.open(selectedContactIds);
            }
        };

        ContactManagerSourceProfileController.prototype.refreshMediaList = function refreshMediaList() {
            let _this = angular.element(document.getElementsByClassName('sourceProfilePage')).scope().sourceController;
            _this.ContactSelector.deselectAll();
            _this.$scope.$digest();
        };

        ContactManagerSourceProfileController.prototype.nextPageContacts = function nextPageContacts() {
            this.ContactStreamData.nextPage().then(function () {
                if (this.ContactSelector.allSelected && this.ContactStreamData.contactArray.length > 25) {
                    this.ContactSelector.selectAllForNextPage(this.ContactStreamData.contactArray, null, null, this.predictionContactFilter);
                }

                this.PageStateService.set('ContactArray', this.ContactStreamData.contactArray);
            }.bind(this));
        };

        ContactManagerSourceProfileController.prototype.scrollToTop = function scrollToTop() {
            this.$rootScope.$broadcast('resetScroll', {duration: 400});
        };
}());
